import {Locales} from '@netx/core-next/locales/utils/Locales';

export const SystemLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.system'),
}));

export const SystemLoginsLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.logins'),
}));

export const SystemMenuSectionLabel = Locales((i18n) => ({
	about: i18n('i18n.about'),
	attributes: i18n('i18n.attributes'),
	infrastructure: i18n('i18n.infrastructure'),
	integrations: i18n('i18n.integrations'),
	setup: i18n('i18n.setup'),
	team: i18n('i18n.team'),
}));
